import { Component, Input, OnInit } from '@angular/core';
import { IReaction } from 'app/shared/models/iReaction';

@Component({
  selector: 'app-reaction-list-dialog',
  template: `
    <h2 mat-dialog-title>{{ 'Reactions' | preventHardcoding }}</h2>

    <mat-dialog-content class="dialog-content">
      <mat-tab-group mat-stretch-tabs>
        <mat-tab
          label="{{ 'All' | preventHardcoding }} ({{ reactions?.length || 0 }})"
        >
          <div class="users-scroll">
            <div class="user" *ngFor="let u of reactions">
              <app-clickable-username
                [userId]="u.uid"
                [showImg]="true"
                [reaction]="u.reaction"
              ></app-clickable-username>
            </div>
          </div>
        </mat-tab>

        <ng-container *ngFor="let emoji of emojiList">
          <mat-tab *ngIf="grouped[emoji]?.length">
            <ng-template mat-tab-label>
              <mat-icon>{{ emoji | preventHardcoding }}</mat-icon>
              <span>&nbsp;({{ grouped[emoji].length }})</span>
            </ng-template>

            <div class="users-scroll">
              <div class="user" *ngFor="let u of grouped[emoji]">
                <app-clickable-username
                  [userId]="u.uid"
                  [showImg]="true"
                  [reaction]="u.reaction"
                ></app-clickable-username>
              </div>
            </div>
          </mat-tab>
        </ng-container>
      </mat-tab-group>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>
        {{ 'Close' | preventHardcoding }}
      </button>
    </mat-dialog-actions>
  `,
  styles: [
    `
      :host {
        display: flex;
        flex-direction: column;
        height: 100%;
      }

      .dialog-content {
        display: flex;
        flex-direction: column;
        overflow: hidden;
        height: 70vh;
        max-height: 500px;
      }

      mat-tab-group {
        flex: 1 1 auto;
        display: flex;
        flex-direction: column;
        height: 100%;
      }

      .users-scroll {
        flex: 1 1 auto;
        overflow-y: auto;
        padding: 10px;
        display: flex;
        flex-direction: column;
        gap: 10px;
      }

      mat-dialog-actions {
        flex-shrink: 0;
      }

      ::ng-deep .mat-tab-label {
        min-width: unset !important;
      }
    `,
  ],
})
export class ReactionListDialogComponent implements OnInit {
  @Input() reactions: { uid: string; reaction: IReaction }[] = [];
  @Input() emojiList: string[] = [];
  @Input() grouped: Record<string, { uid: string; reaction: IReaction }[]> = {};

  ngOnInit() {}
}
